import { Link } from 'react-router-dom';
import { ALINEA_GLOSSARY, glossaryCategories } from '../data/alineaGlossary.js';
import './GlosarioALINEA.css';

export default function GlosarioALINEA() {
    const categories = glossaryCategories();

    return (
        <div className="container glosario-page animate-in">
            <header className="glosario-head">
                <h1>Glosario ALINEA</h1>
                <p className="text-muted glosario-lead">
                    Referencia oficial del lenguaje ALINEA: perfiles maestros (Constante, Impulsivo, Analítico, Social),
                    ontologías, jornada, registro de manada, EPA, alertas, CID y biometría. En la app, muchos términos
                    llevan ℹ con la misma definición; comparte este glosario con encargados y operarios en capacitación.
                </p>
                <p className="text-muted text-sm glosario-count">
                    {ALINEA_GLOSSARY.length} entradas · {categories.length} categorías
                </p>
            </header>

            {categories.map((cat) => (
                <section key={cat} className="glosario-section glass-card">
                    <h2 className="glosario-cat">{cat}</h2>
                    <ul className="glosario-list">
                        {ALINEA_GLOSSARY.filter((e) => e.category === cat).map((entry) => (
                            <li key={entry.id} className="glosario-item">
                                <h3>{entry.title}</h3>
                                <p className="glosario-short">{entry.short}</p>
                                <p className="glosario-def">{entry.definition}</p>
                                {entry.match?.length > 1 ? (
                                    <p className="glosario-aliases text-muted text-sm">
                                        También: {entry.match.slice(1).join(' · ')}
                                    </p>
                                ) : null}
                            </li>
                        ))}
                    </ul>
                </section>
            ))}

            <p className="glosario-foot text-muted text-sm">
                <Link to="/">← Volver al panel</Link>
            </p>
        </div>
    );
}
